// extracted by mini-css-extract-plugin
export default {"modalBodyStyle":"createShowModal_modalBodyStyle__zygb6","modal":"createShowModal_modal__jQ8I8","marginArea":"createShowModal_marginArea__QH1I0"};